export function getBase64Image(img: HTMLImageElement): string {
  // We create a HTML canvas object that will create a 2d image
  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext('2d'); // This will draw image
  ctx.drawImage(img, 0, 0);
  // Convert the drawn image to Data URL
  const dataURL = canvas.toDataURL('image/png');
  return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
}
